import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './vuex/store'
import axios from 'axios'
import moment from 'moment'
import * as CONSTANTS from '@/shared/constants'

window.eventBus = new Vue();
Vue.config.productionTip = false


Vue.prototype.$CONSTANTS = CONSTANTS;
Vue.prototype.$axios = axios;
Vue.prototype.$moment = moment;
Vue.prototype.$requiredBlur = { required: true, message: 'Campo obrigatório.', trigger: 'blur'};
Vue.prototype.$requiredChange = { required: true, message: 'Campo obrigatório.', trigger: 'change'};
Vue.prototype.$emailBlur = { type: 'email', message: 'E-mail inválido.', trigger: 'blur' };
Vue.prototype.$dataBlur = { validator: (rule, value, callback) => {

  if(!value){
      callback();
      return false;
  }
      
  if (value.length == 10 && !moment(value, 'DD/MM/YYYY').isValid()) {
      callback(new Error('Data inválida.'));
  } else {
      callback();
  }

}, trigger: 'blur' };

Vue.prototype.$registroBlur = { validator: (rule, value, callback) => {

  value = value.replace(/\.|\-/g, '');
 
  if(!value || value.length != 32){
      callback();
      return false;
  }

  let numero = '';
	let dv = '';
	let dvCalculado = '';

	dv = value.substring(30, 32);
	numero = value.substring(0, 30);

	for(let n = 1; n <= 2; n++){

		let soma = 0;
		let mult = (n == 1) ? 2 : 1;
		
		for(let i = 0; i<= numero.length -1; i++){

			if(mult > 10)            
			mult = 0
			
			soma += (mult * parseInt(numero.charAt(i)));
			mult++;
		}

		let dvTemp = soma % 11;

		if(dvTemp == 10)
		dvTemp = 1;
		
		numero = numero + dvTemp;

		dvCalculado += dvTemp.toString();

  }

  if(dv == dvCalculado){

    callback();

  }else{

    callback(new Error('Registo inválido.'));
  }
  
}, trigger: 'blur' };

Vue.prototype.$cpfBlur = { validator: (rule, value, callback) => {

  if(value == null || value.length < 14){
    callback();
    return false;	
  }

  let cpf = value.replace(/[^\d]+/g,'');

  if (cpf.length != 11 || 
  cpf == "00000000000" || 
  cpf == "11111111111" || 
  cpf == "22222222222" || 
  cpf == "33333333333" || 
  cpf == "44444444444" || 
  cpf == "55555555555" || 
  cpf == "66666666666" || 
  cpf == "77777777777" || 
  cpf == "88888888888" || 
  cpf == "99999999999"){
    callback(new Error('CPF Inválido.'));
    return false;
  }		

  let add = 0;	
  for (let i=0; i < 9; i ++)		
  add += parseInt(cpf.charAt(i)) * (10 - i);	
  let rev = 11 - (add % 11);	
  if (rev == 10 || rev == 11)		
    rev = 0;	
  if (rev != parseInt(cpf.charAt(9))){	
    callback(new Error('CPF Inválido.'));
    return false;
  }		
  
  add = 0;	
  for (let i = 0; i < 10; i ++)		
  add += parseInt(cpf.charAt(i)) * (11 - i);	
  rev = 11 - (add % 11);	
  if (rev == 10 || rev == 11){
    rev = 0;	
  }

  if (rev != parseInt(cpf.charAt(10))){

    callback(new Error('CPF Inválido.'));
    return false;
  }	

  callback();
 
}, trigger: 'blur' };


Vue.prototype.$removerAcentos = ( newStringComAcento ) => {
  var string = newStringComAcento;
	var mapaAcentosHex 	= {
		a : /[\xE0-\xE6]/g,
    A : /[\xC0-\xC6]/g,
    e : /[\xE8-\xEB]/g,
    E : /[\xC8-\xCB]/g,
    i : /[\xEC-\xEF]/g,
    I : /[\xCC-\xCF]/g,
    o : /[\xF2-\xF6]/g,
    O : /[\xD2-\xD6]/g,
    u : /[\xF9-\xFC]/g,
    U : /[\xD9-\xDC]/g,
    c : /\xE7/g,
    C : /\xC7/g,
    n : /\xF1/g,
    N : /\xD1/g,
	};

	for ( var letra in mapaAcentosHex ) {
		var expressaoRegular = mapaAcentosHex[letra];
		string = string.replace( expressaoRegular, letra );
	}

	return string;
}

Vue.prototype.$removerEspacosDuplos = ( newStringComEspaco ) => {
  var string = newStringComEspaco;
	string = string.replace(/\s{2,}/g, ' ');

	return string;
}

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import money from './shared/moneys'
Vue.use(money, {precision: 4})

import cPanel from './shared/c-panel/c-panel'
Vue.component('c-panel', cPanel);

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/pt'
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI, { size: 'small', locale });

Vue.filter('truncate', function(text, length, clamp){

  if(!text)
    return '-';

  clamp = clamp || '...';
  return text.length > length ? text.slice(0, length) + clamp : text;
});

axios.interceptors.response.use((response) => {
  
  if(typeof response.data.erro !== 'undefined' && (response.data.erro.cod == 800 || response.data.erro.cod == 801)){

    router.push('/not-permission');
  }

  return response;

});

router.afterEach(() => {
  const year = new Date().getFullYear()
  document.title = `Pré-matrícula Online ${year} - Vitória da Conquista - Bahia`
})

new Vue({  
  store,
  router,
  render: h => h(App)
}).$mount('#app')